import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { WithLazy } from "@quintype/components";
import { DfpComponent } from "./dfp-component";
import "./ads.m.css";
import useAdType from "../helper/useAdType";

const AdSlot = ({ id, ad_type, adStyleName = "", isExternalAdPath = false }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const isAdfree = get(qtState, ["config", "subscriber"]) === "true";

  const networkId = get(qtState, ["config", "ads-config", "network_id"], "");
  const adConfig = get(qtState, ["config", "ads-config", "slots", ad_type], {});
  const { sizes, ad_unit, view_port_size_mapping, externalPath } = adConfig;
  const adUnitPath = isExternalAdPath ? externalPath : `${networkId}/${ad_unit}`;

  if (isAdfree) return null;

  const DfpComponentWrapper = () => (
    <DfpComponent
      adStyleName={adStyleName}
      id={id}
      path={adUnitPath}
      size={sizes}
      viewPortSizeMapping={view_port_size_mapping}
      type="top-ad"
    />
  );

  return <DfpComponentWrapper />;
};

const AdContainer = React.memo(
  ({ id, desktop, mobile, AdClassName = "", showText = true, isExternalAdPath = false, storyPageAds = false, cta = "sidebar" }) => {
    const qtState = useSelector((state) => get(state, ["qt"], {}));
    const subscriptionConfig = get(qtState, ["data", "subscriptionConfig", "ad-lite-cta"], {});
    const isAdfree = get(qtState, ["config", "subscriber"]) === "true";
    if (isAdfree) return null;

    return (
      <div styleName={storyPageAds ? "Adcontainer story-page-ad" : "Adcontainer"}>
        { showText ?
          <span styleName="container-text" className="ad-text">{cta === "inStory" ? subscriptionConfig?.["inStory-text"] || "Story continues below. " : subscriptionConfig?.["advertisment-text"] || "Advertisement. "}
            <a
              styleName="red-text"
              href="/subscribe?utm_source=dh_site&utm_medium=ad_cta&utm_campaign=dh_subscription"
              onClick={(e) => {
                e.preventDefault();
                if (window) {
                  const { getAuthStatus } = require("../helper/datalayer-utils");
                  const { status, uuid } = getAuthStatus();
                  const formattedStatus = status === "not_logged_in" ? "non_logged_in" : status;

                  let slotName = desktop || mobile || id || "NA";
                  if (typeof slotName === "string" && slotName.includes("/")) {
                    const parts = slotName.split("/");
                    slotName = parts[parts.length - 1];
                  }

                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "ad_lite_button_click",
                    ad_slot_name: slotName,
                    auth_status: formattedStatus,
                    uuid: uuid
                  });
                }
                setTimeout(() => {
                  window.location.assign("/subscribe?utm_source=dh_site&utm_medium=ad_cta&utm_campaign=dh_subscription");
                }, 300);
              }}
            >
              {subscriptionConfig?.["cta-text"] || "Go Ad Lite"}
            </a>
          </span>
         : null }

        <div className="ad-background" styleName={`ad-background ${AdClassName}`}>
          {typeof window !== "undefined" && window.innerWidth >= 768 && desktop ? (
            <div styleName="desktop">
              <AdSlot id={`${id}`} ad_type={desktop} isExternalAdPath={isExternalAdPath} />
            </div>
          ) : null}

          {typeof window !== "undefined" && window.innerWidth <= 768 && mobile ? (
            <div styleName="mobile">
              <AdSlot id={`${id}`} ad_type={mobile} isExternalAdPath={isExternalAdPath} />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
);

const HeaderDesktopAd = () => {
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], "home-page"));
  const adType = useAdType();
  const adsId = {
    "home-page": "div-gpt-ad-1680156194475-0",
    "story-page": "div-gpt-ad-1680156622758-0",
    "izooto-top": "div-gpt-ad-1711971157718-0"
  };
  const ads = {
    "home-page": "DH_Desktop_HP_Billboard_Top",
    "story-page": "DH_Desktop_AT_Billboard",
    "izooto-top": "DH_Desktop_AT_Billboard_ym"
  };

  return (
    <div styleName="header-container">
      <AdContainer
        AdClassName="standard-970x90"
        id={adType === "izooto" ? adsId["izooto-top"] : adsId[pageType] || "div-gpt-ad-1680156194475-0"}
        desktop={adType === "izooto" ? ads["izooto-top"] : ads[pageType] || "DH_Desktop_HP_Billboard_Top"}
        isExternalAdPath={adType === "izooto" ? true : false}
        cta={pageType === "story-page" ? "inStory" : ""}
      />
    </div>
  );
};

const OutOfPageAd = () => {
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);
  return (
    <>
      {!isMobile ? (
        <AdContainer
          className="hide-mobile"
          showText={false}
          id="div-gpt-ad-1680157592679-0"
          desktop="DH_Desktop_Interstitial"
        />
      ) : (
        <AdContainer
          className="hide-desktop"
          showText={false}
          id="div-gpt-ad-1680157627881-0"
          mobile="DH_Mobile_Interstitial"
        />
      )}
    </>
  );
};

export { AdSlot, AdContainer, HeaderDesktopAd, OutOfPageAd };
